export default __webpack_public_path__ + "static/projects-48e0a12d53016666c82547829d208cb4.jpg";